import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
const SortingIcon = ({ direction, disabled = false, ...rest }) => {
    const tokens = useTokens();
    const styles = {
        svg: {
            transform: direction === 'desc' ? `rotate(180deg)` : `rotate(0deg)`,
        },
        path: {
            fill: tokens.IconPrimaryDark,
            opacity: disabled ? '50%' : '100%',
        },
    };
    return (React.createElement("svg", { width: "24", height: "24", style: styles.svg, viewBox: "0 0 24 24", fill: "#751F00", xmlns: "http://www.w3.org/2000/svg", ...rest },
        React.createElement("path", { style: styles.path, d: "M12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22ZM17 14L12 9L7 14H17Z" })));
};
export default SortingIcon;
